import React, { useState, useEffect } from "react";
import { Menu } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { RouteConfig } from "../../../route";

const MenuConfig = [
  {
    key: "sceneManege",
    label: "场景管理",
    children: [
      {
        key: "sceneList",
        label: "场景管理",
      },
    ],
  },
  {
    key: "moduleManage",
    label: "模块管理",
    children: [
      {
        key: "modulePage",
        label: "模块管理",
      },
    ],
  },
  {
    key: "paymentManage",
    label: "支付管理",
    children: [
      {
        key: "paymentOrderPage",
        label: "支付订单",
      },
      {
        key: "paymentStatisticsPage",
        label: "支付统计",
      },
    ],
  },
  {
    key: "userManage",
    label: "用户管理",
    children: [
      {
        key: "userManagement",
        label: "用户管理",
      },
      {
        key: "userFeedbackPage",
        label: "用户反馈",
      },
    ],
  },
  {
    key: "systemConfig",
    label: "系统配置",
    children: [
      {
        key: "systemConfigPage",
        label: "系统配置",
      },
      {
        key: "appUpdatePage",
        label: "App更新配置",
      },
    ],
  },
  {
    key: "taskManage",
    label: "任务管理",
    children: [
      {
        key: "taskPage",
        label: "任务管理",
      },
    ],
  },
  {
    key: "videoManage",
    label: "视频工具",
    children: [
      {
        key: "videoMultiAudio",
        label: "多角色语音生成",
      },
    ],
  },
];

function PageMenu() {
  const [currentKey, setCurrentKey] = useState("sceneList");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    if (path === RouteConfig.sceneList.path) {
      setCurrentKey("sceneList");
    } else if (
      path.startsWith(RouteConfig.sceneDetail.path.replace(":id", ""))
    ) {
      setCurrentKey("sceneList");
    } else if (path === RouteConfig.userManagement.path) {
      setCurrentKey("userManagement");
    } else if (path === RouteConfig.userFeedbackPage.path) {
      setCurrentKey("userFeedbackPage");
    } else if (path === RouteConfig.systemConfigPage.path) {
      setCurrentKey("systemConfigPage");
    } else if (path === RouteConfig.appUpdatePage.path) {
      setCurrentKey("appUpdatePage");
    } else if (path === RouteConfig.modulePage.path) {
      setCurrentKey("modulePage");
    } else if (path === RouteConfig.paymentOrderPage.path) {
      setCurrentKey("paymentOrderPage");
    } else if (path === RouteConfig.paymentStatisticsPage.path) {
      setCurrentKey("paymentStatisticsPage");
    } else if (path === RouteConfig.taskPage.path) {
      setCurrentKey("taskPage");
    } else if (path === RouteConfig.videoMultiAudio.path) {
      setCurrentKey("videoMultiAudio");
    }
  }, [location.pathname]);

  const clickMenu = (item: any) => {
    console.log(item);
    setCurrentKey(item.key);
    const route = RouteConfig[item.key as keyof typeof RouteConfig];
    if (route) {
      navigate(route.path);
    }
  };

  return (
    <Menu
      onClick={clickMenu}
      style={{ width: "100%" }}
      defaultOpenKeys={[
        "sceneManege",
        "moduleManage",
        "paymentManage",
        "userManage",
        "systemConfig",
        "taskManage",
        "videoManage",
      ]}
      selectedKeys={[currentKey]}
      mode="inline"
      items={MenuConfig}
    />
  );
}

export default PageMenu;
